import { error } from "console";
import apiConfig from "constants/apiConfig";
import { ApplicationCost, ApplicationPosts, CampaignApplication, ShortlistedSummary } from "types/campaign/applications";
import axiosClient from "utils/axiosClient";

export const fetchCampaignApplications = async (agencyId: string, campaignId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_APPLICATIONS.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), {params: {...payload, limit: 24}});

    return response.data;
}

export const fetchApplication = async (agencyId: string, campaignId: string, applicationId: string) : Promise<CampaignApplication> => {
    const response = await axiosClient.get(apiConfig.FETCH_APPLICATION.url.replace('<agencyId>', agencyId)
    .replace('<campaignId>', campaignId)
    .replace('<applicationId>', applicationId)
);

return response.data.application;
}

export const processApplication = async (agencyId: string, campaignId: string, applicationId: string, payload: any) => {
    const response = await axiosClient.put(apiConfig.PROCESS_APPLICATION.url.replace('<agencyId>', agencyId)
    .replace('<campaignId>', campaignId)
    .replace('<applicationId>', applicationId), payload)

    return response.data;
}

export const bookmarkApplciation = async (agencyId: string, campaignId: string, applicationId: string, bookmark: 'y' | 'n', force: boolean = false) => {
    const response = await axiosClient.post(apiConfig.BOOKMARK_APPLICATION.url.replace('<agencyId>', agencyId)
    .replace('<campaignId>', campaignId)
    .replace('<applicationId>', applicationId), {bookmark, force})

    return response.data
}

export const fetchApplicationMedia = async (agencyId: string, campaignId: string, influencerId: string, payload: any = {}) : Promise<ApplicationPosts> => {
    const response = await axiosClient.get(apiConfig.FETCH_APPLICATION_POSTS.url.replace('<agencyId>', agencyId)
    .replace('<campaignId>', campaignId)
    .replace('<influencerId>', influencerId), {params: {sort: 'like_count'}});

    return response.data;
}

export const fetchApplicationCost = async (agencyId: string, campaignId: string, applicationId: string) : Promise<ApplicationCost> => {
    const response = await axiosClient.get(apiConfig.FETCH_APPLICATION_COST.url.replace('<agencyId>', agencyId)
    .replace('<campaignId>', campaignId)
    .replace('<applicationId>', applicationId));
    
    return response.data;
}

export const fetchShortlistedSummary = async (agencyId: string, campaignId: string) : Promise<ShortlistedSummary> => {
    const response = await axiosClient.get(apiConfig.FETCH_SHORTLISTED_SUMMARY.url.replace('<agencyId>', agencyId)
    .replace('<campaignId>', campaignId));

    return response.data;
}

export const approveShortlistedApplication = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.post(apiConfig.APPROVE_SHORTLISTED_APPLICATION.url.replace('<agencyId>', agencyId)
    .replace('<campaignId>', campaignId));

    return response.data;
}